// import axios from 'axios'
// import { getMenuList } from '@/api/index'
import lazyLoading from './lazyLoading.js'
// import router from '@/router/index'
// import Cookies from 'js-cookie'
import meneDataConfig from '../data/menuData.js'
import { setStore, getStore, removeStore } from '@/libs/storage'
import { JSEncrypt } from 'jsencrypt'
import SparkMd5 from 'spark-md5'
let util = {}
// 私钥
let privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAL867S7IS1rA5v3UBL5iF+T4emOEVRc1XZ3g2Ik2ZkjDFWkk4NGpoG6rMnkOrMaxKg8YPAeqKgNHmZFH7vTyQokwcGkTMGIYy3G6Sy67ol88WiJbM1/XrbrQASMPeJKu/kO2rg6dYN3YyAhaTx93c0lrUx2SxfBLQ5+KgiPtzUOvAgMBAAECgYAWO0CFts1j4Jc6HSLsCzVh7i00Upcd2ptmllQ2J3fer6dWkO3+Ee1P0GFOx5D4jHIqTRP1hCfcN7+3rxgtq9hmLM+alWi7+pKOfutxXhXIPpAqI7N7NBR5zBx/rOQFluquL+mFdihwUp54fbkOwDYepGx2FinlU/ltED+YLxZISQJBAPfWYmMEag7ECQKrxCVs0mff2K4eLwE3ecOgrXTZLIts+7qNZ/PEQqYkzpCIDAaQ9z0ec59SQz+yFGdCM8Jbe70CQQDFh0OSQcMs/SAGJgJXVpFr7wZhIB0yRLtEJKh+xzuRzPw65ww2kWa2W3xPYyIMShVYidtbG+3l4JqBAX6T/h3bAkBmk7fzDZ+r7t1f2qH7b3gCgDaZkmqYEVL3cih4xW5XYsspol9VGHUReQh576UyjouWI2Vtmsm0sksZleAAYIbtAkA6hpt0yFtmBxHoAHcNHa80xbukJ3m/HTJHPH1YIvv5dTz+ztqFiItgWLb6Zqr97S1p8F64Hgxc4jGlK6Yvf0mlAkEAlXMRb3YuHGp+K7cDMjfzS/ztgoWStavXo1cvpCtm6t9PKaUT94QQdsV8ymxkJ3xjJbYCe/+KMUo9VY0vAFggjQ=='


util.title = function(title) {
  title = title || '源码熊学生端'
  window.document.title = title
}

util.millsToTime = function(mills) {
  if (!mills) {
    return ''
  }
  let s = mills / 1000
  if (s < 60) {
    return s.toFixed(0) + ' 秒'
  }
  let m = s / 60
  if (m < 60) {
    return m.toFixed(0) + ' 分钟'
  }
  let h = m / 60
  if (h < 24) {
    return h.toFixed(0) + ' 小时'
  }
  let d = h / 24
  if (d < 30) {
    return d.toFixed(0) + ' 天'
  }
  let month = d / 30
  if (month < 12) {
    return month.toFixed(0) + ' 月'
  }
  let year = month / 12
  return year.toFixed(0) + ' 年'
}

/**
 *  格式化时间  日期 比如 new Date()
 */
util.dateFormat = date => {
  if (!date) {
    // 如果date=undefined时进入
    return ''
  } else {
    date = new Date(date)
  }

  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  const t = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  return t
}

/**
 *  获取当前时间
 */
util.getCurrDate = () => {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  const t = year + month + day + hours + minutes + seconds
  return t
}

util.inOf = function(arr, targetArr) {
  let res = true
  arr.forEach(item => {
    if (targetArr.indexOf(item) < 0) {
      res = false
    }
  })
  return res
}

util.oneOf = function(ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true
  } else {
    return false
  }
}

util.getRouterObjByName = function(routers, name) {
  if (!name || !routers || !routers.length) {
    return null
  }
  // debugger;
  let routerObj = null
  for (let item of routers) {
    if (item.name === name) {
      return item
    }
    routerObj = util.getRouterObjByName(item.children, name)
    if (routerObj) {
      return routerObj
    }
  }
  return null
}

util.handleTitle = function(vm, item) {
  if (typeof item.title === 'object') {
    return vm.$t(item.title.i18n)
  } else {
    return item.title
  }
}

util.setCurrentPath = function(vm, name) {
  let title = ''
  let isOtherRouter = false
  vm.$store.state.app.routers.forEach(item => {
    if (item.children.length === 1) {
      if (item.children[0].name === name) {
        title = util.handleTitle(vm, item)
        if (item.name === 'otherRouter') {
          isOtherRouter = true
        }
      }
    } else {
      item.children.forEach(child => {
        if (child.name === name) {
          title = util.handleTitle(vm, child)
          if (item.name === 'otherRouter') {
            isOtherRouter = true
          }
        }
      })
    }
  })
  let currentPathArr = []
  if (name === 'home_index') {
    currentPathArr = [
      {
        title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
        path: '',
        name: 'home_index'
      }
    ]
  } else if ((name.indexOf('_index') >= 0 || isOtherRouter) && name !== 'home_index') {
    currentPathArr = [
      {
        title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
        path: '/home',
        name: 'home_index'
      },
      {
        title: title,
        path: '',
        name: name
      }
    ]
  } else {
    let currentPathObj = vm.$store.state.app.routers.filter(item => {
      if (item.children.length <= 1) {
        return item.children[0].name === name
      } else {
        let i = 0
        let childArr = item.children
        let len = childArr.length
        while (i < len) {
          if (childArr[i].name === name) {
            return true
          }
          i++
        }
        return false
      }
    })[0]
    if (currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
      currentPathArr = [
        {
          title: '首页',
          path: '',
          name: 'home_index'
        }
      ]
    } else if (currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
      currentPathArr = [
        {
          title: '首页',
          path: '/home',
          name: 'home_index'
        },
        {
          title: currentPathObj.title,
          path: '',
          name: name
        }
      ]
    } else {
      let childObj = currentPathObj.children.filter(child => {
        return child.name === name
      })[0]
      currentPathArr = [
        {
          title: '首页',
          path: '/home',
          name: 'home_index'
        },
        {
          title: currentPathObj.title,
          path: '',
          name: currentPathObj.name
        },
        {
          title: childObj.title,
          path: currentPathObj.path + '/' + childObj.path,
          name: name
        }
      ]
    }
  }
  vm.$store.commit('setCurrentPath', currentPathArr)

  return currentPathArr
}

util.openNewPage = function(vm, name, argu, query) {
  if (!vm.$store) {
    return
  }
  let pageOpenedList = vm.$store.state.app.pageOpenedList
  let openedPageLen = pageOpenedList.length
  let i = 0
  let tagHasOpened = false
  while (i < openedPageLen) {
    if (name === pageOpenedList[i].name) {
      // 页面已经打开
      vm.$store.commit('pageOpenedList', {
        index: i,
        argu: argu,
        query: query
      })
      tagHasOpened = true
      break
    }
    i++
  }
  if (!tagHasOpened) {
    let tag = vm.$store.state.app.tagsList.filter(item => {
      if (item.children) {
        return name === item.children[0].name
      } else {
        return name === item.name
      }
    })
    tag = tag[0]
    if (tag) {
      tag = tag.children ? tag.children[0] : tag
      if (argu) {
        tag.argu = argu
      }
      if (query) {
        tag.query = query
      }
      vm.$store.commit('increateTag', tag)
    }
  }
  vm.$store.commit('setCurrentPageName', name)
}

util.toDefaultPage = function(routers, name, route, next) {
  let len = routers.length
  let i = 0
  let notHandle = true
  while (i < len) {
    if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
      route.replace({
        name: routers[i].children[0].name
      })
      notHandle = false
      next()
      break
    }
    i++
  }
  if (notHandle) {
    next()
  }
}

util.fullscreenEvent = function(vm) {
  vm.$store.commit('initCachepage')
}

// 将Csv文件解析为二维数组
export const getArrayFromFile = file => {
  let nameSplit = file.name.split('.')
  let format = nameSplit[nameSplit.length - 1]
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.readAsText(file) // 以文本格式读取
    let arr = []
    reader.onload = function(evt) {
      let data = evt.target.result // 读到的数据
      let pasteData = data.trim()
      arr = pasteData
        .split(/[\n\u0085\u2028\u2029]|\r\n?/g)
        .map(row => {
          return row.split('\t')
        })
        .map(item => {
          return item[0].split(',')
        })
      if (format === 'csv') resolve(arr)
      else reject(new Error('[Format Error]:不是Csv文件'))
    }
  })
}

// 将二维数组转为表格数据
export const getTableDataFromArray = array => {
  let columns = []
  let tableData = []
  if (array.length > 1) {
    let titles = array.shift()
    columns = titles.map(item => {
      return {
        title: item,
        key: item
      }
    })
    tableData = array.map(item => {
      let res = {}
      item.forEach((col, i) => {
        res[titles[i]] = col
      })
      return res
    })
  }
  return {
    columns,
    tableData
  }
}

util.initRouter = function(vm) {
  const constRoutes = []
  const otherRoutes = []

  // 404路由需要和动态路由一起加载
  const otherRouter = [
    {
      path: '/*',
      name: 'error-404',
      meta: {
        title: '404-页面不存在'
      },
      component: 'error-page/404'
    }
  ]
  // 判断用户是否登录
  // let userInfo = Cookies.get('userInfo')
  let userInfo = window.localStorage.getItem('userInfo')
  // window.localStorage.setItem('userType', JSON.parse(userInfo).userType)

  if (!userInfo) {
    // 未登录
    return
  }
  if (!vm.$store.state.app.added) {
    // 第一次加载 读取数据
    // let accessToken = window.localStorage.getItem('accessToken')
    // 加载菜单
    // axios.get(getMenuList, { headers: { 'accessToken': accessToken } }).then(res => {
    let menuData = meneDataConfig.menuData

    if (!menuData) {
      return
    }
    if (JSON.parse(userInfo).organizationId === '-1') {
      menuData[0].children.splice(5, 2)
      menuData[0].children.splice(1, 1)
    }
    if (JSON.parse(userInfo).schoolStatus === 0) {
      if (JSON.parse(userInfo).organizationId === '-1') {
        menuData[0].children.splice(1, 1)
      }else{
        menuData[0].children.splice(2, 1)
      }
    }else{
      menuData[0].children.splice(1, 1)
    }
    console.log("222222",menuData);
    
    util.initAllMenuData(constRoutes, menuData)
    util.initRouterNode(otherRoutes, otherRouter)
    // 添加所有主界面路由
    vm.$store.commit(
      'updateAppRouter',
      constRoutes.filter(item => item.children.length > 0)
    )
    // 添加全局路由
    vm.$store.commit('updateDefaultRouter', otherRoutes)
    // 添加菜单路由
    util.initMenuData(vm, menuData)
    // 缓存数据 修改加载标识
    window.localStorage.setItem('menuData', JSON.stringify(menuData))
    vm.$store.commit('setAdded', true)
    // })
  } else {
    // 读取缓存数据
    let data = window.localStorage.getItem('menuData')
    if (!data) {
      vm.$store.commit('setAdded', false)
      return
    }
    let menuData = JSON.parse(data)
    // 添加菜单路由
    util.initMenuData(vm, menuData)
  }
}

// 添加所有顶部导航栏下的菜单路由
util.initAllMenuData = function(constRoutes, data) {
  let allMenuData = []
  data.forEach(e => {
    if (e.type === -1) {
      e.children.forEach(item => {
        allMenuData.push(item)
      })
    }
  })
  util.initRouterNode(constRoutes, allMenuData)
}

// 生成菜单格式数据
util.initMenuData = function(vm, data) {
  const menuRoutes = []
  let menuData = data
  // 顶部菜单
  let navList = []
  menuData.forEach(e => {
    let nav = {
      name: e.name,
      title: e.title,
      icon: e.icon
    }
    navList.push(nav)
  })
  if (navList.length < 1) {
    return
  }
  // 存入vuex
  vm.$store.commit('setNavList', navList)
  let currNav = window.localStorage.getItem('currNav')
  if (currNav) {
    // 读取缓存title
    for (var item of navList) {
      if (item.name === currNav) {
        vm.$store.commit('setCurrNavTitle', item.title)
        break
      }
    }
  } else {
    // 默认第一个
    currNav = navList[0].name
    vm.$store.commit('setCurrNavTitle', navList[0].title)
  }
  vm.$store.commit('setCurrNav', currNav)
  for (var it of menuData) {
    if (it.name === currNav) {
      // 过滤
      menuData = it.children
      break
    }
  }
  util.initRouterNode(menuRoutes, menuData)
  // 刷新界面菜单
  vm.$store.commit(
    'updateMenulist',
    menuRoutes.filter(item => item.children.length > 0)
  )

  let tagsList = []
  vm.$store.state.app.routers.map(item => {
    if (item.children.length <= 1) {
      tagsList.push(item.children[0])
    } else {
      tagsList.push(...item.children)
    }
  })
  vm.$store.commit('setTagsList', tagsList)
}

// 生成路由节点
util.initRouterNode = function(routers, data) {
  for (var item of data) {
    let menu = Object.assign({}, item)
    // menu.component = import(`@/views/${menu.component}.vue`);
    menu.component = lazyLoading(menu.component)

    if (item.children && item.children.length > 0) {
      menu.children = []
      util.initRouterNode(menu.children, item.children)
    }

    let meta = {}
    // 给页面添加权限、标题、第三方网页链接
    meta.permTypes = menu.permTypes ? menu.permTypes : null
    meta.title = menu.title ? menu.title + ' - 源码熊人工智能教育平台' : null
    meta.url = menu.url ? menu.url : null
    menu.meta = meta

    routers.push(menu)
  }
}
util.isJson = data => {
  try {
    const obj = JSON.parse(data)
    if (typeof obj === 'object' && obj) return true
    else return false
  } catch (err) {
    return false
  }
}
util.obCopy = data => {
  return JSON.parse(JSON.stringify(data))
}
util.localGet = key => {
  const data = getStore(key)
  if (util.isJson(data)) return JSON.parse(data)
  else return data
}
util.localSet = (key, data) => {
  setStore(key, data)
  // typeof data !== 'object' && localStorage.setItem(key, data)
  // typeof data === 'object' && localStorage.setItem(key, JSON.stringify(data))
}
util.localRem = key => {
  removeStore(key)
}
util.upload = {
  file: () => `${util.base}/upload/matchPic`
}
// 上传图片组件需要参数函数
util.uploadFileUrlParams = (url, isAdmin) => {
  // 统一请求路径前缀
  let base = '/xboot'
  // 统一请求路径前缀
  let baseAdmin = '/admin'
  let accessToken = getStore('accessToken')

  return { url: isAdmin ? `${base}${url}` : `${baseAdmin}${url}`, headers: { accessToken: accessToken, from: 'pc' } }
}
// 下载文件
util.handleMDFN = (url, fileName) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET',url,true);
  xhr.responseType = "blob";
  xhr.onload = () => {
      if(xhr.status === 200){
          let blob = xhr.response;
          if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
          } else {
              let link = document.createElement('a');
              let body = document.querySelector('body');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.style.display = 'none';
              body.appendChild(link);
              link.click();
              body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
          };
      }
  }
  xhr.send();
}
// 对象按首字母排序
util.objKeySort = obj => {
  var newkey = Object.keys(obj).sort()
  var newObj = {}
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]]
  }
  return newObj
}
//使用私钥解密
util.usePrivateKeyToDecrypt = (sk)=>{
  var decrypt = new JSEncrypt();
  decrypt.setPrivateKey('-----BEGIN RSA PRIVATE KEY-----'+ privateKey +'-----END RSA PRIVATE KEY-----');
  var uncrypted = decrypt.decrypt(sk);
  // console.log('解密后数据:%o', uncrypted);
  return uncrypted
}
// 请求接口参数 md5 加密
util.md5Encryption = obj => {
  if(obj.sign){
    delete obj.sign
  }
  if (typeof obj != 'object') return
  
  let stringA = ''
  obj.timestamp = Date.parse(new Date())
  obj.nonce = Date.parse(new Date()) + Math.random()
  let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
  if(!userInfo) return;
  // obj.accessKey = userInfo.accessKey
  obj.accessKey = '1337209402259804161'
  // obj.secretKey = 'd930ea5d5a258f4f'
  obj.secretKey = util.usePrivateKeyToDecrypt('gueuZUEFH4vdnBEpXoJEuAHfdn9pe+yE/ji86qeEejwwZxUyh/eaGTlX8amu3xrwRnk4JdH1w0znIjwmLDf/tHxaf/wlBPUV+8BKpSQtsewfE/sHZdc/d3fBwq5yrD/ER8xQmV3qT4qoaUR0mha9V1N/DlCQtOOZp0PXlNSwEqA=')
  // obj.secretKey = util.usePrivateKeyToDecrypt(userInfo.secretKey)
  let sortList = util.objKeySort(obj)
  for (const key in sortList) {
    stringA += `${key}=${sortList[key]}&`
  }
  stringA = stringA.slice(0, -1)
  
  // console.log(stringA,'stringA')
  delete obj.secretKey
  obj.sign = SparkMd5.hash(stringA).toUpperCase()
  return obj
}
// 数字转文字
util.convertToChinese = num => {
  var N = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  var str = num.toString()
  var len = num.toString().length
  var C_Num = []
  for (var i = 0; i < len; i++) {
    C_Num.push(N[str.charAt(i)])
  }
  return C_Num.join('')
}
util.timestampToDate = (timestamp)=>{
  let date = new Date(Number(timestamp))
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1) <10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1) +'-'
  let D = date.getDate() + ' '
  let h = date.getHours() + ':'
  let m = date.getMinutes() + ':'
  let s = date.getSeconds() 
  return Y + M + D + h + m + s
}
// 计算时间
util.countTime = dateTimeStamp => {
  let minute = 1000 * 60 //把分，时，天，周，半个月，一个月用毫秒表示
  let hour = minute * 60
  let day = hour * 24
  let week = day * 7
  let halfamonth = day * 15
  let month = day * 30
  let now = new Date().getTime() //获取当前时间毫秒
  let result
  let diffValue = now - dateTimeStamp //时间差
  if (diffValue < 0) {
    return 0
  }
  let minC = diffValue / minute //计算时间差的分，时，天，周，月
  let hourC = diffValue / hour
  let dayC = diffValue / day
  let weekC = diffValue / week
  let monthC = diffValue / month
  if (monthC >= 1 && monthC <= 3) {
    result = ' ' + parseInt(monthC) + '月前'
  } else if (weekC >= 1 && weekC <= 4) {
    result = ' ' + parseInt(weekC) + '周前'
  } else if (dayC >= 1 && dayC <= 7) {
    result = ' ' + parseInt(dayC) + '天前'
  } else if (hourC >= 1 && hourC <= 24) {
    result = ' ' + parseInt(hourC) + '小时前'
  } else if (minC >= 1 && minC <= 60) {
    result = ' ' + parseInt(minC) + '分钟前'
  } else if (diffValue >= 0 && diffValue <= minute) {
    result = '刚刚'
  } else {
    let datetime = new Date()
    datetime.setTime(dateTimeStamp)
    let Nyear = datetime.getFullYear()
    let Nmonth = datetime.getMonth() + 1 < 10 ? '0' + (datetime.getMonth() + 1) : datetime.getMonth() + 1
    let Ndate = datetime.getDate() < 10 ? '0' + datetime.getDate() : datetime.getDate()
    let Nhour = datetime.getHours() < 10 ? '0' + datetime.getHours() : datetime.getHours()
    let Nminute = datetime.getMinutes() < 10 ? '0' + datetime.getMinutes() : datetime.getMinutes()
    let Nsecond = datetime.getSeconds() < 10 ? '0' + datetime.getSeconds() : datetime.getSeconds()
    result = Nyear + '-' + Nmonth + '-' + Ndate
  }
  return result
}
export default util



// WEBPACK FOOTER //
// ./src/libs/util.js